"use client"

import { motion } from "framer-motion"
import { useTranslations } from "next-intl"
import { cn } from "@/lib/utils"
import { Pacifico } from "next/font/google"
const pacifico = Pacifico({
  subsets: ["latin"],
  weight: ["400"],
  variable: "--font-pacifico",
})

export default function HeroHeading() {
  const t = useTranslations("hero")
  return (
    <motion.h1
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.3 }}
      className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight"
    >
      <span className="block text-white mb-2">{t("title.line1")}</span>
      <span className="block text-white mb-2">{t("title.line2")}</span>
      <span
        className={cn(
          "block mb-1 pb-2 pr-2 w-fit mx-auto lg:mx-0 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent",
          pacifico.className,
        )}
        style={{
          textShadow: "0 0 40px rgba(147, 51, 234, 0.5)",
        }}
      >
        {t("title.line3")}
      </span>
      <span className="block text-gray-300">{t("title.line4")}</span>
    </motion.h1>
  )
}
